import { range } from "lodash";
import { Button, ButtonProps, Dropdown, DropdownProps, Flex } from "antd";
import { StrokeIcon } from "components/icons";
import { CheckOutlined } from "@ant-design/icons";
import { useAntTheme } from "hooks/useAntTheme";
import { useTranslate } from "@refinedev/core";

export const Stroke = ({
  value,
  onChange,
  min = 1,
  max = 5,
  dropdownProps,
  buttonProps,
}: {
  value?: number;
  onChange: (value?: number) => void;
  min?: number;
  max?: number;
  dropdownProps?: DropdownProps;
  buttonProps?: ButtonProps;
}) => {
  const { theme } = useAntTheme();
  const t = useTranslate();
  const strokeValues = range(min, max + 1);
  const strokeOptions = strokeValues.map((px) => ({
    key: px,
    label: (
      <div
        style={{
          minWidth: 30,
          height: px,
          backgroundColor: theme.colorTextBase,
        }}
      />
    ),
    icon: (
      <CheckOutlined style={{ opacity: value === px ? 1 : 0, fontSize: 10 }} />
    ),
  }));

  const dropDownOptions = [
    {
      key: "none",
      label: (
        <div>
          {t("components.templates.SettingsToolbar.controls.stroke.none")}
        </div>
      ),
      icon: (
        <CheckOutlined
          data-testid="check-icon"
          style={{ opacity: value ? 0 : 1, fontSize: 10 }}
        />
      ),
    },
    ...strokeOptions,
  ];

  return (
    <Dropdown
      menu={{
        items: dropDownOptions,
        onClick: (item) => {
          const value = item.key === "none" ? undefined : Number(item.key);
          onChange(value);
        },
      }}
      trigger={["click"]}
      overlayStyle={{ maxWidth: 100 }}
      getPopupContainer={(triggerNode) =>
        triggerNode.parentElement ?? triggerNode
      }
      {...dropdownProps}
    >
      <Button
        data-testid="stroke-button"
        icon={
          <Flex align="center" justify="center">
            <StrokeIcon fill={theme.colorTextBase} />
          </Flex>
        }
        type="text"
        size="middle"
        {...buttonProps}
      />
    </Dropdown>
  );
};
